export default {
  type: 'menu',
  code: '20000000',
  create: {
    type: 'menu',
    code: '20010000'
  }
}
